export { DigitalKeys as FlexiPassDigitalKeys } from './flexipassKeys';
export { DigitalKeys as RemotelockDigitalKeys } from './remotelockKeys';
